/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import { gql } from 'urql';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type LoyaltyPointsRewardsQueryVariables = Exact<{ [key: string]: never }>;

export type LoyaltyPointsRewardsQuery = {
  readonly loyaltyProfile: {
    readonly customerId: string;
    readonly pointsRewards: ReadonlyArray<{
      readonly __typename: 'PointsReward';
      readonly id: string;
      readonly points: number;
      readonly redeemable: boolean;
      readonly assetUrl: string | null;
      readonly name: string;
    }> | null;
  } | null;
};

export const LoyaltyPointsRewardsDocument = gql`
  query LoyaltyPointsRewards {
    loyaltyProfile {
      customerId
      pointsRewards {
        id
        __typename
        points
        name: displayName
        redeemable
        assetUrl
      }
    }
  }
`;

export function useLoyaltyPointsRewardsQuery(
  options?: Omit<Urql.UseQueryArgs<LoyaltyPointsRewardsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<LoyaltyPointsRewardsQuery, LoyaltyPointsRewardsQueryVariables>({
    query: LoyaltyPointsRewardsDocument,
    ...options,
  });
}
